import {styled} from "styled-components";

export const StatusBadge = styled.div`
  border: 1px solid var(--ion-color-medium);
  background-color: rgba(255, 255, 255, 0.5);
  padding: 0.075rem 0.25rem;
  border-radius: 0.25rem;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
`;
